
import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Testimonial data
const testimonials = [
  {
    name: "Mr. Rajesh Mehta",
    role: "Business Traveller",
    quote: "Meghana Cabs exceeded my expectations with their punctual service and courteous drivers. It's my go-to cab service for all outstation trips.",
    image: "https://yourdomain.com/wp-content/uploads/2021/09/testimonial-1.jpg"
  },
  {
    name: "Ms. Priya Sharma",
    role: "IT Professional",
    quote: "Booking with Meghana Cabs is seamless. Their Innova Crysta was clean, comfortable, and perfect for our weekend getaway.",
    image: "https://yourdomain.com/wp-content/uploads/2021/09/testimonial-2.jpg"
  },
  {
    name: "Mr. Anil Deshmukh",
    role: "Corporate Executive",
    quote: "Their professional chauffeurs and prompt service make Meghana Cabs the ideal choice for my business travel needs in and around Pune.",
    image: "https://yourdomain.com/wp-content/uploads/2021/09/testimonial-3.jpg"
  },
  {
    name: "Ms. Neha Verma",
    role: "Frequent Traveller",
    quote: "I’ve used Meghana Cabs multiple times. Whether it’s Pune Darshan or an outstation trip to Goa, they always deliver reliable service.",
    image: "https://yourdomain.com/wp-content/uploads/2021/10/testimonial-4.jpg"
  }
];

export default function TestimonialsSlider() {
  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4500,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 }
      }
    ]
  };

  return (
    <section
      className="testimonials-section"
      style={{
        padding: '40px 0',
        background: '#f8f9fa',
        overflowX: 'hidden' // Prevent horizontal scroll
      }}
    >
      <div
        className="container"
        style={{
          maxWidth: 1200,
          margin: '0 auto',
          padding: '0 15px',
          overflowX: 'hidden'
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: 30 }}>
          <div style={{ color: '#F47C7C', fontWeight: 'bold' }}>Testimonials & Reviews</div>
          <h2>What They’re Saying</h2>
        </div>

        <Slider {...settings}>
          {testimonials.map((t, i) => (
            <div key={i} style={{ padding: 15 }}>
              <div
                style={{
                  background: '#fff',
                  padding: 20,
                  borderRadius: 12,
                  boxShadow: '0 4px 10px rgba(0,0,0,0.06)',
                  textAlign: 'center',
                  height: '100%',
                  boxSizing: 'border-box'
                }}
              >
                {/* Image (optional, add correct domain or use local assets) */}
                {/* <img
                  src={t.image}
                  alt={t.name}
                  style={{ borderRadius: '50%', width: 80, height: 80, objectFit: 'cover' }}
                /> */}

                <div style={{ color: '#FFA500', marginTop: 10 }}>
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="fas fa-star" />
                  ))}
                </div>

                <p style={{ fontStyle: 'italic', margin: '15px 0' }}>{t.quote}</p>
                <strong style={{ color: '#333' }}>{t.name}</strong><br />
                <span style={{ color: '#777' }}>{t.role}</span>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}
